// extracted by mini-css-extract-plugin
export default {"frame":"GeofenceMap_frame__OOMbv","canvas":"GeofenceMap_canvas__S4xCv","empty":"GeofenceMap_empty__kGqlS"};